import microuniversoApi from "app/api/microuniversoApi";

import { tratamentoErroPadrao } from "app/use-cases";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";

import { ModalConfigurarWhatsapp } from "./modalConfigurarWhatsapp";
import { StatusWhatsappResponse } from "app/types/Whatsapp/StatusWhatsappResponse";
import { times } from "ramda";
import { ErroDaApiEnterprise } from "app/api/classes/ErroDaApiEnterprise";
import { set } from "date-fns";

export type ModalConfigurarWhatsappContainerProps = {
    exibirModalWhatsapp: boolean;
    codigoVendedor: string;
    onApagarSessao: (inibirMensagemDeErro: boolean) => void;
    onObterStatus: () => Promise<StatusWhatsappResponse>;
    onClose: () => void;
    onConfigurado: () => void;
};

export const ModalConfigurarWhatsappContainer = (
    props: ModalConfigurarWhatsappContainerProps
) => {
    const [qrCodeBase64, setQrCodeBase64] = useState<string>("");
    const [erroAoObterQrCode, setErroAoObterQrCode] = useState<boolean>(false);
    const [carregandoQrCode, setCarregandoQrCode] = useState<boolean>(false);


    const obterQrCode = async () => {
        setCarregandoQrCode(true);
        setQrCodeBase64("");
        await props.onApagarSessao(true);
        setErroAoObterQrCode(false);
        try {
            const response = await microuniversoApi.Whatsapp.configurarWhatsappVendedor(props.codigoVendedor);
            setQrCodeBase64(response.qrcode);
        } catch (error) {
            setErroAoObterQrCode(true);
            console.log("Erro ao obter QR Code:", error);
            globalMU.showErrorMessage((error as ErroDaApiEnterprise)?.mensagem ?? "Erro desconhecido ao obter QR Code.");
        }
        finally {
            setCarregandoQrCode(false);
        }
    }

    useEffect(() => {
        if (props.exibirModalWhatsapp && props.codigoVendedor) { 
            obterQrCode();
        }
    }, [props.exibirModalWhatsapp, props.codigoVendedor]);

    useEffect(() => {
        if (!props.exibirModalWhatsapp) return;
        if (!props.codigoVendedor) return;
        if (carregandoQrCode) return;
        

        const intervalId = setInterval(async () => {
           const status = await props.onObterStatus();
           if(status.statusSessao == "CONFIGURADO") {
                globalMU.showSuccessMessage("Sessão do WhatsApp configurada com sucesso.");
                await new Promise(resolve => setTimeout(resolve, 600));
                props.onClose();
            }


        }, 10000);

        return () => {
            clearInterval(intervalId);
        };
    }, [props.exibirModalWhatsapp, props.codigoVendedor]);

    return (
        <>
            {props.exibirModalWhatsapp && (
                <ModalConfigurarWhatsapp
                    qrCodeBase64={qrCodeBase64}
                    erroAoObterQrCode={erroAoObterQrCode}
                    carregandoQrCode={carregandoQrCode}
                    onGerarQrCode={() => {
                        setErroAoObterQrCode(false);
                        obterQrCode();
                    }}
                    onClose={() => {
                        props.onClose();
                    }}
                    onApagarSessao={(inibirMensagemDeErro: boolean) => {
                        setErroAoObterQrCode(false);
                        props.onApagarSessao(inibirMensagemDeErro);
                    }}
                />
            )}
        </>
    );
};
